<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input type="input" name="where_journal_time" :value="where_journal_time" />
        <input type="input" name="where_year" :value="where_year" />
        <input type="input" name="where_relation" :value="where_relation" />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'

export default {
  data() {
    return {
      changVisible: false,
      loading: true,
      token: localStorage.getItem('token'),
      where_student_no: '',
      where_name: '',
      where_programme: '',
      where_journal_time: '',
      where_year: '',
      where_relation: ''
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
    },
    //页面初始化时加载的事件
    show(where_student_no, where_name, where_programme, where_journal_time, where_year, where_relation) {
      this.changVisible = true
      this.where_student_no = where_student_no
      this.where_name = where_name
      this.where_programme = StrUtils.replaceFields(where_programme.toString())
      this.where_journal_time = where_journal_time.length == 0 ? '' : where_journal_time[0] + '-' + where_journal_time[1]
      this.where_year = where_year.length == 0 ? '' : where_year[0] + '-' + where_year[1]
      this.where_relation = where_relation
      this.$nextTick(() => {
        const from = document.getElementById('form_exportAis')
        from.action = URL_PATH + CApi.api_exportAisJournalSum + '?token=' + this.token
        from.submit()
        this.close()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/exportAisJournalSumDialog.vue